import { render } from "./RegisterUserPage.vue?vue&type=template&id=8d6b97d6&ts=true"
import script from "./RegisterUserPage.vue?vue&type=script&lang=ts"
export * from "./RegisterUserPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__